<template>
    <div class="app">
        <div class="app-body app flex-row align-items-center">
            <main class="container">
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'auth',
    components: {}
  }
</script>



// WEBPACK FOOTER //
// Auth.vue?09cef3f2